import * as actionTypes from './actionTypes'
import { employeeService } from '../../service'
import { errorHelper } from '../../common/helpers'
import { constants } from '../../common/constants'

export function getEmployees({ page = constants.GET_ALL_ITEMS, filter, reset, storeId } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_EMPLOYEES })

            dispatch({ type: actionTypes.FETCH_EMPLOYEES })

            const response = await employeeService.getAll(page, filter, storeId)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_EMPLOYEES_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_EMPLOYEES_SUCCESS,
                payload: {
                    employees: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_EMPLOYEES_FAILURE)
        }
    }
}
export function getEmployeesWithSize({ page = constants.GET_ALL_ITEMS, filter, size, reset } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_EMPLOYEES })

            dispatch({ type: actionTypes.FETCH_EMPLOYEES })
            const response = await employeeService.getAllWithSize(page, filter, size)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_EMPLOYEES_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_EMPLOYEES_SUCCESS,
                payload: {
                    employees: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_EMPLOYEES_FAILURE)
        }
    }
}

export function resetEmployees() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_EMPLOYEES
        })
    }
}
export function getEmployee(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.RESET_EMPLOYEE })
            dispatch({ type: actionTypes.FETCH_EMPLOYEE })

            const response = await employeeService.get(id)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_EMPLOYEE_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_EMPLOYEE_SUCCESS,
                payload: { employee: data }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_EMPLOYEE_FAILURE)
        }
    }
}
export function resetEmployee() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_EMPLOYEE
        })
    }
}

export function createEmployee(employee) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.CREATE_EMPLOYEE })

            const response = await employeeService.create(employee)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.CREATE_EMPLOYEE_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.CREATE_EMPLOYEE_SUCCESS,
                payload: {
                    employee: data
                }
            })

            dispatch({ type: actionTypes.RESET_CREATE_EMPLOYEE })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.CREATE_EMPLOYEE_SUCCESS)
        }
    }
}
export function resetCreateEmployee() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_CREATE_EMPLOYEE
        })
    }
}

export function updateEmployee(id, employee) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.UPDATE_EMPLOYEE })

            const response = await employeeService.update(id, employee)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.UPDATE_EMPLOYEE_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.UPDATE_EMPLOYEE_SUCCESS,
                payload: { employee: data }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.UPDATE_EMPLOYEE_FAILURE)
        }
    }
}
export function resetUpdateEmployee() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_UPDATE_EMPLOYEE
        })
    }
}

export function updateEmployeeState(id, isActive) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.UPDATE_EMPLOYEE_STATE })
            const response = await employeeService.updateState(id, isActive)
            const data = response.data
            if (data.status == 400) {
                dispatch({
                    type: actionTypes.UPDATE_EMPLOYEE_STATE_FAILURE,
                    payload: { error: data.message }
                })
                return
            }
            dispatch({
                type: actionTypes.UPDATE_EMPLOYEE_STATE_SUCCESS,
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.UPDATE_EMPLOYEE_STATE_FAILURE)
        }
    }
}
export function resetUpdateEmployeeState() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_UPDATE_EMPLOYEE_STATE
        })
    }
}

export function deleteEmployee(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.DELETE_EMPLOYEE })

            await employeeService.deleteEmployee(id)

            dispatch({
                type: actionTypes.DELETE_EMPLOYEE_SUCCESS,
                payload: {
                    employee: { id }
                }
            })

            dispatch({ type: actionTypes.RESET_DELETE_EMPLOYEE })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.DELETE_EMPLOYEE_FAILURE)
        }
    }
}

export function uploadEmployeePhoto(id, photo) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.UPLOAD_EMPLOYEE_PHOTO })
            const response = await employeeService.uploadPhoto(id, photo)
            const data = response.data

            dispatch({
                type: actionTypes.UPLOAD_EMPLOYEE_PHOTO_SUCCESS,
                payload: {
                    photoUrl: data.photoUrl
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.UPLOAD_EMPLOYEE_PHOTO_FAILURE)
        }
    }
}

export function deleteEmployeePhoto(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.DELETE_EMPLOYEE_PHOTO })
            await employeeService.deletePhoto(id)

            dispatch({
                type: actionTypes.DELETE_EMPLOYEE_PHOTO_SUCCESS
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.DELETE_EMPLOYEE_PHOTO_FAILURE)
        }
    }
}

export function getEmployeeSells({ page = constants.GET_ALL_ITEMS, startDate, endDate, id } = {}) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.RESET_EMPLOYEE_SELLS })
            dispatch({ type: actionTypes.FETCH_EMPLOYEE_SELLS })

            const response = await employeeService.getSells(page, startDate, endDate, id)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_EMPLOYEE_SELLS_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_EMPLOYEE_SELLS_SUCCESS,
                payload: {
                    sells: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize,
                    totalSold: data.totalSold,
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_EMPLOYEE_SELLS_FAILURE)
        }
    }
}

export function resetEmployeeSells() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_EMPLOYEE_SELLS
        })
    }
}

export function getEmployeeSellsItems({ page = constants.GET_ALL_ITEMS, startDate, endDate, id } = {}) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.RESET_EMPLOYEE_SELLS_ITEMS })
            dispatch({ type: actionTypes.FETCH_EMPLOYEE_SELLS_ITEMS })

            const response = await employeeService.getItemSells(page, startDate, endDate, id)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_EMPLOYEE_SELLS_ITEMS_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_EMPLOYEE_SELLS_ITEMS_SUCCESS,
                payload: {
                    items: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize,
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_EMPLOYEE_SELLS_FAILURE)
        }
    }
}

export function resetEmployeeSellsItems() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_EMPLOYEE_SELLS
        })
    }
}


export function getEmployeesByStore({ store_id, reset }) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_EMPLOYEES_BY_STORE })

            dispatch({ type: actionTypes.FETCH_EMPLOYEES_BY_STORE })
            const response = await employeeService.getEmployeesByStore(store_id)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_EMPLOYEES_BY_STORE_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_EMPLOYEES_BY_STORE_SUCCESS,
                payload: {
                    employees: data.data,
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_EMPLOYEES_BY_STORE_FAILURE)
        }
    }
}

export function resetEmployeesByStore() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_EMPLOYEES_BY_STORE
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/employee/actions.js